import { WORKFLOWS } from "../../../config/workflows";
import { useOnboardingDraft } from "../OnboardingContext";
import styles from "../OnboardingWizard.module.css";
import type { StepProps } from "../OnboardingWizard";

// Workflow step, shown only to the trades tiers (WORKFLOW_STEP_TIERS): the
// purchase includes one launch workflow, picked here. Single-select for now;
// stored on the submission and read by ops, nothing downstream yet.
export const WorkflowStep = ({ onNext, onBack }: StepProps): JSX.Element => {
  const { draft, update } = useOnboardingDraft();
  const selected = draft.selectedWorkflow;
  // A stale draft could carry a retired slug; Next re-checks it's still real.
  const selectedKnown = WORKFLOWS.some((w) => w.slug === selected);

  return (
    <section className={styles.card}>
      <div className={styles.stepHeader}>
        <h2 className={styles.stepTitle}>Which workflow should we build first?</h2>
        <p className={styles.stepHint}>
          Your plan includes one of these workflows, set up for you. Pick the one that would save
          you the most time this month - you can add more later.
        </p>
      </div>

      <div className={styles.field}>
        <div className={`${styles.optionGrid} ${styles.optionGridUniform}`}>
          {WORKFLOWS.map((workflow) => {
            const isSelected = selected === workflow.slug;
            return (
              <button
                key={workflow.slug}
                type="button"
                className={[styles.optionTile, isSelected ? styles.optionTileSelected : ""].join(" ")}
                onClick={() => update("selectedWorkflow", workflow.slug)}
                aria-pressed={isSelected}
              >
                <span className={styles.optionTitle}>{workflow.name}</span>
                <span className={styles.optionMeta}>{workflow.blurb}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className={styles.footer}>
        <button type="button" className={styles.secondaryBtn} onClick={onBack}>Back</button>
        <button type="button" className={styles.primaryBtn} onClick={onNext} disabled={!selectedKnown}>Next</button>
      </div>
    </section>
  );
};
